module.exports = __webpack_public_path__ + "media/images/icons/flags/NG-72c2d5bb4fcd99fa2964365f17b55f27.svg";